import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
import { CookiesProvider } from 'react-cookie';
//import '@amzn/awsui-components-react/sass/constants.scss';
import './styles/main.scss';

ReactDOM.render(
  <CookiesProvider>
    <App />
  </CookiesProvider>,
  document.getElementById('app'),
);
